import React from "react";
import { Typography, Button } from "antd";
import moment from "moment";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import OrdersList from "../../../components/scheduling/OrdersList";

const { Title } = Typography;

const SchedulingHeader = (props) => {
  const {
    currentDate,
    effective_orders,
    order_time_extractions,
    onFilterOrdersChanged,
    onNextDate,
    onPreviousDate,
    filteredOrders,
  } = props;

  const social_security = "ביטוח לאומי";
  const holocast_survivors_fund = "הקרן לנפגעי שואה";
  const ministry_of_defence = "משרד הביטחון";

  const ordersPalette = {
    [social_security]: "#53C31A",
    [holocast_survivors_fund]: "#F99646",
    [ministry_of_defence]: "#6C64FE",
  };

  return (
    <div style={{ display: "flex", paddingBottom: "10px" }}>
      <div style={{ display: "flex", minWidth: "220px" }}>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              width: "200px",
              paddingBottom: "5px",
            }}
          >
            <Button
              type="text"
              shape="circle"
              icon={<RightOutlined />}
              onClick={onPreviousDate}
            />
            <Title level={4} style={{ margin: "0px", lineHeight: 1.5 }}>
              {moment(currentDate).format("MMMM YYYY")}
            </Title>
            <Button
              type="text"
              shape="circle"
              icon={<LeftOutlined />}
              onClick={onNextDate}
            />
          </div>
        </div>
      </div>
      <div style={{ justifyContent: "center", display: "flex", flex: 1 }}></div>
      <OrdersList
        effective_orders={effective_orders}
        order_time_extractions={order_time_extractions}
        ordersPalette={ordersPalette}
        onFilterOrdersChanged={onFilterOrdersChanged}
        mode={"scheduling"}
        filteredOrders={filteredOrders}
      />
    </div>
  );
};

export default SchedulingHeader;
